import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {KennethMustDie} from "../KennethMustDie";
import {KMDGameAssets} from "../KMDGameAssets";
import {gsap} from "gsap";
import {MULTIPLIER_AND_WAYS_ANIMATIONS} from "../server/IKMDData";
import {KMDGameMode} from "../server/KMDGameMode";

export class KMDPossibleWays extends PIXI.Container implements StageLayer {
    private _holder: PIXI.spine.Spine;
    private _possibleWays: PIXI.BitmapText;

    constructor() {
        super();
        this.name = "";

        this.init();
    }

    private _value: number;

    get value(): number {
        return this._value;
    }

    public updateWays(): void {
        let val: number = 1;

        KennethMustDie.SYMBOLS_NUM_PER_REEL.forEach((value: number) => {
            val *= value;
        });

        if (val === this._value) {
            return;
        }
        this._value = val;

        this._possibleWays.text = "" + val;
        this._possibleWays.fontSize = 50;

        while (this._possibleWays.textWidth > 120) {
            this._possibleWays.fontSize--;
        }

        if (val !== 480) {
            this.playHolderAnimation(KennethMustDie.model.data.mode);
        }
    }

    // #281
    public turnOffForCFS(): void {
        this.alpha = 0;
    }

    // #281
    public transitionForCFS(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to(this, {
            duration: duration,
            alpha: 1
        });

        return tl;
    }

    // #540
    public onGameModeChanged(mode: string): void {
        this.playHolderAnimation(mode);
    }

    private init(): void {
        this._value = -1;

        this._holder = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("ways"));
        this._holder.position.set(73, 175);

        this._possibleWays = new PIXI.BitmapText("", {
            fontName: KMDGameAssets.BITMAP_FONT_MULTIPLIER,
            fontSize: 50
        });
        this._possibleWays.anchor = new PIXI.Point(0.5, 0.5);
        this._possibleWays.position.set(73, 175);

        this.addChild(this._holder, this._possibleWays);

        this.updateWays();
    }

    private playHolderAnimation(mode: string): void {
        let animName: string = MULTIPLIER_AND_WAYS_ANIMATIONS.MAIN;

        if (mode.indexOf(KMDGameMode.FREESPIN_SUPER) > -1) { // SFS and SFS_AVALANCHE
            animName = MULTIPLIER_AND_WAYS_ANIMATIONS.SFS;
        } else if (mode.indexOf(KMDGameMode.FREESPIN) > -1) { // FS/CFS and CFS/FS_AVALANCHE
            animName = MULTIPLIER_AND_WAYS_ANIMATIONS.FS;
        }

        animName += MULTIPLIER_AND_WAYS_ANIMATIONS.HELPER;

        this._holder.state.setAnimation(0, animName, false);
    }
}